import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import { PaginationBehaviour } from '@jetshop/ui/Pagination';
import { styled } from 'linaria/react';
import get from 'lodash.get';
import React from 'react';
import CategoryHeader from '../CategoryPage/CategoryHeader';
import MaxWidth from '../Layout/MaxWidth';
import { Pagination } from '../Pagination/Pagination';
import { theme } from '../Theme';
import CategoryHeaderLoadingState from './CategoryHeaderLoadingState';
import Filters from './Filters';
import ProductGrid from './ProductGrid';

const Container = styled(MaxWidth)`
  padding-top: 2rem;
  ${theme.above.sm} {
    padding-top: 2rem;
  }
`;

const CategoryWrapper = styled('div')``;

const Category = ({ category, result, cacheHit }) => {
  if (!category) {
    return (
      <CategoryWrapper>
        <CategoryHeaderLoadingState />;
      </CategoryWrapper>
    );
  }

  return (
    <CategoryWrapper>
      <>
        <CategoryHeader
          category={category}
          parents={get(result.data, 'route.parents')}
        />

        <Container>
          {category.products?.filters?.length > 0 && (
            <Filters
              filters={category.products?.filters || []}
              sortOrders={category.products?.sortOrders || []}
              result={result}
            />
          )}
          <div>
            <ProductGrid
              products={category.products.result}
              listName={category.name}
              categoryPath={
                category.isDynamic ? null : get(result.data, 'route')
              }
              loading={result.loading}
              imageSizes={[1 / 2, 1 / 2, 1 / 3, 1 / 4]}
            />
          </div>

          <PaginationContext.Consumer>
            {props => (
              <PaginationBehaviour
                {...props}
                total={category.products.totalResults}
              >
                {props => <Pagination {...props} />}
              </PaginationBehaviour>
            )}
          </PaginationContext.Consumer>
        </Container>
      </>
    </CategoryWrapper>
  );
};

export default Category;
